/**
 * @generated SignedSource<<9a0c04d45fd0fc4a77868750a4036a27>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type importCatalogPaginationFragmentQuery$variables = {
  category?: string | null;
  count?: number | null;
  cursor?: string | null;
  macroCategory?: string | null;
  provider?: ProductProvider | null;
  search?: string | null;
};
export type importCatalogPaginationFragmentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"importCatalogPaginationFragment__providerProducts">;
};
export type importCatalogPaginationFragmentQuery = {
  response: importCatalogPaginationFragmentQuery$data;
  variables: importCatalogPaginationFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "category"
  },
  {
    "defaultValue": 1,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": "1",
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "macroCategory"
  },
  {
    "defaultValue": "PRINTFUL",
    "kind": "LocalArgument",
    "name": "provider"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "category",
  "variableName": "category"
},
v2 = {
  "kind": "Variable",
  "name": "macroCategory",
  "variableName": "macroCategory"
},
v3 = {
  "kind": "Variable",
  "name": "provider",
  "variableName": "provider"
},
v4 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*:: as any*/),
  (v3/*:: as any*/),
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "importCatalogPaginationFragmentQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "importCatalogPaginationFragment__providerProducts"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "importCatalogPaginationFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "ProviderProductsConnection",
        "kind": "LinkedField",
        "name": "providerProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProviderProductsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductProviderListItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "filters": [
          "search",
          "category",
          "macroCategory",
          "provider"
        ],
        "handle": "connection",
        "key": "importCatalogPaginationFragment_providerProducts",
        "kind": "LinkedHandle",
        "name": "providerProducts"
      }
    ]
  },
  "params": {
    "cacheID": "a7dd64541e774e2be5e8841edb989eb8",
    "id": null,
    "metadata": {},
    "name": "importCatalogPaginationFragmentQuery",
    "operationKind": "query",
    "text": "query importCatalogPaginationFragmentQuery(\n  $category: String = null\n  $count: Int = 1\n  $cursor: String = \"1\"\n  $macroCategory: String = null\n  $provider: ProductProvider = PRINTFUL\n  $search: String = \"\"\n) {\n  ...importCatalogPaginationFragment__providerProducts_2nPjk2\n}\n\nfragment importCatalogPaginationFragment__providerProducts_2nPjk2 on Query {\n  providerProducts(first: $count, after: $cursor, search: $search, category: $category, macroCategory: $macroCategory, provider: $provider) {\n    edges {\n      node {\n        id\n        name\n        imageUrl\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9808d745923bffab06a56cb2f449af87";

export default node;
